import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFTextArea from '../../../controls/tempRHFControls/RHFTextArea';
import useFetch from 'use-http';
import PersonnelToast from '../../components/PersonnelToast';

interface IPaperworkCommentDialogProps {
    dialogName: string;
    lmNo: number;
    hideDialog: () => void;
    showToast: (message: string, color?: string, persistent?: boolean) => void;
}

const PaperworkCommentDialog = (props: IPaperworkCommentDialogProps) => {
    const { register, errors, setValue, getValues, reset } = useForm();
    const { get, post, put, response } = useFetch();
    const [paperworkComment, setPaperworkComment] = useState<string>('');
    const [insuranceComment, setInsuranceComment] = useState<string>('');
    const [isNewComment, setIsNewComment] = useState<boolean>(true);
    const [needToClearInsurance, setNeedToClearInsurance] = useState<boolean>(false);
    const [toast, setToast] = useState<{ message: string; color?: string, persistent?: boolean; } | null>(null);

    useEffect(() => {
        onCreate();
        getPaperworkComment();
    }, []);

    // combines comments if artifact data is pulled from the insurance comment table
    useEffect(() => {
        let combinedComment = paperworkComment + '\n' + insuranceComment;
        setValue('comment', combinedComment);
        reset({ 'comment': combinedComment });
    }, [paperworkComment, insuranceComment]);

    useEffect(() => {
        getInsuranceComment();
        getPaperworkComment();
        setIsNewComment(true);
    }, [props.lmNo]);

    const onCreate = () => {
        console.log('PaperworkCommentDialog onCreate()');
        getInsuranceComment();
        getPaperworkComment();
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    const getPaperworkComment = async () => {
        setPaperworkComment('');

        if (props.lmNo !== undefined && props.lmNo !== null && props.lmNo > 0) {
            let result = await get(`/v1.0/landmen/personnel/${props.lmNo}/get-paperwork-comment`);

            if (response.ok) {
                setPaperworkComment(result);
                if (result === '') {
                    setIsNewComment(true);
                } else {
                    setIsNewComment(false);
                }
            } else {
                console.log('error with get');
            }
        }
    };

    const getInsuranceComment = async () => {
        setInsuranceComment('');

        if (props.lmNo !== undefined && props.lmNo !== null && props.lmNo > 0) {
            let result = await get(`/v1.0/landmen/personnel/${props.lmNo}/get-insurance-comment`);

            if (response.ok && result !== '') {
                setNeedToClearInsurance(true);
                setInsuranceComment(result);
            } else {
                console.log('error with get');
            }
        }
    };

    const saveComment = async () => {
        if (needToClearInsurance) {
            // clearing old comment
            let clearData = {
                'lmNo': props.lmNo,
                'text': '',
                'line': 0
            };

            await put(`/v1.0/landmen/personnel/update-insurance-comment`, clearData);

            if (response.ok) {
                setNeedToClearInsurance(false);
            } else {
                console.log('error with put');
                showToast('Unable to clear insurance comment: ' + response, `rgba(255,0,0,0.5)`);
            }
        }
        
        // saving comment
        let c = getValues('comment');
        setPaperworkComment(c);

        let data = {
            'lmNo': props.lmNo,
            'text': c,
            'line': 0
        };

        if (isNewComment) {
            await post(`/v1.0/landmen/personnel/create-paperwork-comment`, data);

            if (response.ok) {
                props.showToast('Paperwork comment created');
                props.hideDialog();
            } else {
                console.log('error with post');
                showToast('Unable to create comment: ' + response, `rgba(255,0,0,0.5)`);
            }
        } else {
            await put(`/v1.0/landmen/personnel/update-paperwork-comment`, data);

            if (response.ok) {
                props.showToast('Paperwork comment updated');
                props.hideDialog();
            } else {
                console.log('error with put');
                showToast('Unable to update comment: ' + response, `rgba(255,0,0,0.5)`);
            }
        }
    };

    return (
        <Dialog title="Paperwork Comment" dialogName={props.dialogName} bodyStyle={{ width: '50%' }}>
            <div>
                {toast && (
                    <PersonnelToast
                        message={toast.message}
                        color={toast.color}
                        onClose={() => setToast(null)}
                        persistent={toast.persistent}
                    />
                )}
            </div>
            <div>
                <form>
                    <div>
                        <RHFTextArea
                            name={'comment'}
                            register={register}
                            errors={errors}
                            style={{ width: '100%', height: '20rem' }}
                        />
                    </div>
                    <div className="form-row" style={{ marginTop: '2rem', marginLeft: '33%', textAlign: 'center' }}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                        <Button
                            className="blue-hover-button"
                            intent="primary"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Save'}
                            onClick={() => saveComment()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default PaperworkCommentDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/paperwork/PaperworkCommentsDialog.tsx